import React, { useState } from "react";
import axiosInstance from "../services/axiosComman";
import { toast } from "react-toastify";

function useAddData() {
  const [isCreateLoading, setIsCreateLoading] = useState(false);
  const addData = async ({
    url,
    value,
    resetForm = () => {},
    onClose = () => {},
    getData = () => {},
    hasFile= false,
    setSelectedFile=()=>{},
    otherFunction=()=>{},
    customMsg = "",
  }) => {
    setIsCreateLoading(true);
    try {
      const res = await axiosInstance.post(url, value);
      if (res.data?.status === true||res.data?.msg=="Data Added Successfully") {
        setIsCreateLoading(false);
        resetForm();
        getData();
        onClose();
        if(hasFile){
          setSelectedFile(null)
        }
        toast.success(
          <p className="test-sm">
            {`${customMsg || res.data.msg || res.data.message || "Data Added Successfully"}`}
          </p>
        );
        otherFunction();
      } else if (res.data?.status === false) {
        setIsCreateLoading(false);
        toast.error(
          <p className="test-sm">
            {`${
              res.data.msg || res.data.message || "Data Added Unsuccessfully"
            }`}
          </p>
        );
      } else {
        setIsCreateLoading(false);
        toast.error(
          <p className="test-sm">
            {`${res.data.msg || res.data.message}` ||
              res.data.error ||
              "Data Added Unsuccessfully"}
          </p>
        );
      }
    } catch (err) {
      setIsCreateLoading(false);
      toast.error(
        <p className="test-sm">{`${
          err.response.data.msg ||
          err.response.data.message ||
          err.response.data.error ||
          "Data Added Unsuccessfully"
        }`}</p>
      );
    } finally {
      setIsCreateLoading(false);
    }
  };
  return { isCreateLoading, addData };
}

export default useAddData;
